/* Anaris bokpräglare: färgval (färgposterna från Shopify), kort för extra plattpar, paketlänkar i stegen, sigillfärg, paketvärde. Laddas efter anaris-bp.js. */
(function () {
  'use strict';
  var st = document.createElement('style');
  st.textContent = '.anaris-lp .bp-nudge,.anaris-lp .bp-nudge.ax-pop{background:#EFE4CF !important;background-image:none !important;color:#1F2722 !important;box-shadow:none !important}' +
    '.anaris-lp .bp-nudge *{color:inherit}' +
    '.anaris-lp .bp-nudge:before,.anaris-lp .bp-nudge:after{content:none !important;display:none !important}' +
    '.anaris-lp .bp-nudge-go{background:#1E3529 !important;color:#fff !important;box-shadow:none !important}';
  document.head.appendChild(st);

  var root = document.querySelector('[data-bp-root]');
  if (!root) return;
  var host = root.querySelector('[data-bp-form]');
  var box = root.querySelector('[data-bp-color]');
  var extra = root.querySelector('[data-bp-extra]');
  var mode = root.getAttribute('data-mode');
  var color = null;
  var sigColor = 'Silver';
  var sigf = null;
  var signote = null;
  var valnote = null;

  if (box) {
    var sws = Array.prototype.slice.call(box.querySelectorAll('.bp-sw'));
    var label = box.querySelector('[data-bp-color-name]');
    var track = document.getElementById('trk');
    var thm = document.getElementById('thm');
    var firstImg = track && track.children[0] ? track.children[0].querySelector('img') : null;
    var origSrc = firstImg ? firstImg.getAttribute('src') : null;
    var origSet = firstImg ? firstImg.getAttribute('srcset') : null;
    var pick = function (sw, fromUser) {
      sws.forEach(function (s) {
        s.setAttribute('aria-checked', s === sw ? 'true' : 'false');
        s.tabIndex = s === sw ? 0 : -1;
      });
      color = sw.getAttribute('data-name');
      window.ANARIS_COLOR = color;
      if (label) label.textContent = color;
      if (!fromUser) return;
      var i = parseInt(sw.getAttribute('data-slide'), 10);
      if (i >= 0 && thm && thm.children[i]) {
        if (firstImg && origSrc) { firstImg.src = origSrc; if (origSet) firstImg.setAttribute('srcset', origSet); }
        thm.children[i].click();
      } else if (firstImg && sw.getAttribute('data-img')) {
        firstImg.removeAttribute('srcset');
        firstImg.src = sw.getAttribute('data-img');
        if (thm && thm.children[0]) thm.children[0].click();
      }
    };
    sws.forEach(function (s) {
      s.addEventListener('click', function () { pick(s, true); });
    });
    if (sws.length) pick(sws[0], false);
  }

  /* Sigillfärg: silver ingår i alla paket och kan inte väljas där. Vid extra sigill väljer kunden färg. */
  var CDN = 'https://cdn.shopify.com/s/files/1/1039/4599/4582/files/';
  var SF = [
    { n: 'Silver', adj: 'silverfärgade', sw: 'linear-gradient(135deg,#f7f7f7,#aeb3b9)', a: 'sigill-silver-ark.png?v=1793804396' },
    { n: 'Guld', adj: 'guldfärgade', sw: 'linear-gradient(135deg,#f8e58c,#c19717)', a: 'sigill-guld-ark.png?v=1793804397' }
  ];
  var scr = document.currentScript || document.querySelector('script[src*="anaris-bp-plus.js"]');
  var cssHref = scr && scr.src ? scr.src.split('anaris-bp-plus.js').join('anaris-bp-sf.css') : '';
  if (host && (mode === 'bokpraglare' || mode === 'sigill')) {
    if (cssHref) { var lk = document.createElement('link'); lk.rel = 'stylesheet'; lk.href = cssHref; document.head.appendChild(lk); }
    var chips = SF.map(function (c, i) {
      return '<button type="button" class="bp-sigf-o" role="radio" aria-checked="' + (i === 0 ? 'true' : 'false') + '" tabindex="' + (i === 0 ? '0' : '-1') + '"><i style="background:' + c.sw + '"></i><span>' + c.n + '</span></button>';
    }).join('');
    sigf = document.createElement('div');
    sigf.className = 'bp-sigf';
    sigf.hidden = mode === 'bokpraglare';
    sigf.innerHTML = '<p class="bp-sigf-hd"><span>' + (mode === 'sigill' ? 'Välj färg på sigillen' : 'Välj färg på dina extra sigill') + '</span><b data-n>' + SF[0].n + '</b></p>' +
      '<div class="bp-sigf-opts" role="radiogroup" aria-label="Sigillfärg">' + chips + '</div>' +
      '<div class="bp-sigf-view"><img data-a alt="" loading="lazy" width="1200" height="1200"></div>' +
      '<p class="bp-sigf-note">' + (mode === 'sigill' ? '' : 'Sigillen som ingår i paketet är alltid silver. Här väljer du färg på de 100 extra sigillen. ') + 'Bilderna är exempel. Färgen och avtrycket kan se något annorlunda ut i verkligheten.</p>';
    var nm = sigf.querySelector('[data-n]');
    var ia = sigf.querySelector('[data-a]');
    var chipEls = Array.prototype.slice.call(sigf.querySelectorAll('.bp-sigf-o'));
    var pickC = function (i, focus) {
      var c = SF[i];
      chipEls.forEach(function (e, k) { e.setAttribute('aria-checked', k === i ? 'true' : 'false'); e.tabIndex = k === i ? 0 : -1; });
      sigColor = c.n;
      nm.textContent = c.n;
      ia.src = CDN + c.a;
      ia.alt = 'Ark med ' + c.adj + ' sigill, 20 ark med 5 sigill i varje';
      if (focus) chipEls[i].focus();
    };
    chipEls.forEach(function (e, i) {
      e.addEventListener('click', function () { pickC(i); });
      e.addEventListener('keydown', function (ev) {
        var k = ev.key, n = SF.length;
        if (k === 'ArrowRight' || k === 'ArrowDown') { ev.preventDefault(); pickC((i + 1) % n, true); }
        else if (k === 'ArrowLeft' || k === 'ArrowUp') { ev.preventDefault(); pickC((i + n - 1) % n, true); }
      });
    });
    pickC(0);
    if (mode === 'bokpraglare') {
      signote = document.createElement('p');
      signote.className = 'bp-signote';
      signote.hidden = true;
      signote.innerHTML = '<b>Silversigill ingår i alla paket.</b> Färgen på sigillen i paketet går inte att välja. Vill du ha en annan färg kan du lägga till extra sigill här nedanför och välja färg.';
      host.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('[data-bp-sigill]')) sigf.hidden = !t.checked;
      });
    }
  }

  /* Paketvärde: Duo och Familj visar vad samma delar kostar köpta var för sig hos oss, och besparingen i procent.
     Räkning: Standard + (extra plattpar x 299 kr) + (extra sigill x 1,29 kr, alltså 129 kr per 100). */
  var EXTRA_PAIR = 299;
  var SIGILL_EACH = 1.29;
  function num(s) { return parseInt(String(s || '').replace(/[^0-9]/g, ''), 10) || 0; }
  function kr(n) { var s = String(Math.round(n)); return (s.length > 3 ? s.slice(0, -3) + ' ' + s.slice(-3) : s) + ' kr'; }
  function pdata(c) {
    var incl = (c.querySelector('.bp-pack-incl') || {}).textContent || '';
    var pm = incl.match(/(\d+)\s*plattpar/i);
    var sm = incl.match(/(\d+)\s*(?:silver)?sigill/i);
    return { price: num((c.querySelector('.bp-pack-price') || {}).textContent), pairs: pm ? parseInt(pm[1], 10) : 0, sig: sm ? parseInt(sm[1], 10) : 0 };
  }
  function packValues() {
    if (mode !== 'bokpraglare' || !host) return;
    var cards = Array.prototype.slice.call(host.querySelectorAll('.bp-pack'));
    var base = null;
    cards.forEach(function (c) {
      var n0 = c.querySelector('.bp-pack-name');
      if (n0 && n0.textContent.trim() === 'Standard') base = pdata(c);
    });
    if (!base || !base.price) return;
    var shown = false;
    cards.forEach(function (c) {
      var d = pdata(c);
      var per = c.querySelector('.bp-pack-per');
      if (!per || !d.price || d.pairs <= base.pairs) return;
      var value = Math.round(base.price + (d.pairs - base.pairs) * EXTRA_PAIR + (d.sig - base.sig) * SIGILL_EACH);
      var pct = Math.floor((value - d.price) / value * 100);
      if (pct < 1) { if (per.textContent) per.textContent = ''; return; }
      shown = true;
      if (per.querySelector('.bp-pv-save')) return;
      per.classList.add('bp-pv');
      per.innerHTML = '<span class="bp-pv-val">Värde ' + kr(value) + '</span><b class="bp-pv-save">Du sparar ' + pct + ' %</b>';
    });
    if (valnote) valnote.hidden = !shown;
  }
  if (mode === 'bokpraglare' && host) {
    valnote = document.createElement('p');
    valnote.className = 'bp-valnote';
    valnote.hidden = true;
    valnote.textContent = 'Värdet är vad samma delar kostar köpta var för sig hos oss: extra plattpar 299 kr och sigill 129 kr per 100.';
    try { new MutationObserver(function () { packValues(); }).observe(host, { childList: true, subtree: true }); } catch (e) { }
    packValues();
  }

  function place() {
    if (!host) return false;
    if (mode !== 'bokpraglare' && mode !== 'sigill') return true;
    if (mode === 'sigill') {
      var tot = host.querySelector('.bp-total');
      if (!tot) return false;
      if (sigf) tot.insertAdjacentElement('beforebegin', sigf);
      return true;
    }
    var packs = host.querySelector('[data-bp-packs]');
    var nudge = host.querySelector('[data-bp-nudge]');
    var addon = host.querySelector('.bp-addon');
    var anchor = addon || nudge || packs;
    if (!anchor) return false;
    if (signote) {
      var before = nudge || packs;
      if (before) {
        before.insertAdjacentElement('afterend', signote);
        signote.hidden = false;
        if (valnote) signote.insertAdjacentElement('afterend', valnote);
      }
    }
    var at = anchor;
    if (sigf && addon) {
      addon.insertAdjacentElement('afterend', sigf);
      var cb = addon.querySelector('[data-bp-sigill]');
      sigf.hidden = !(cb && cb.checked);
      at = sigf;
    }
    if (extra) { at.insertAdjacentElement('afterend', extra); extra.hidden = false; }
    return true;
  }
  if (!place() && host) {
    var tries = 0;
    var iv = setInterval(function () { if (place() || ++tries > 40) clearInterval(iv); }, 150);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-bp-pack]') : null;
    if (!a) return;
    e.preventDefault();
    var want = a.getAttribute('data-bp-pack');
    var cards = document.querySelectorAll('.bp-pack');
    for (var k = 0; k < cards.length; k++) {
      var nm2 = cards[k].querySelector('.bp-pack-name');
      if (nm2 && nm2.textContent.trim() === want) { cards[k].click(); break; }
    }
    if (host) host.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (init && String(init.method).toUpperCase() === 'POST' && url.indexOf('/cart/add') > -1 && init.body && typeof init.body.has === 'function') {
          var isBp = init.body.has('properties[_namnverktyg]');
          if (color && isBp) init.body.set('properties[Färg]', color);
          if (mode === 'bokpraglare' && isBp) {
            init.body.set('properties[Sigill i paketet]', 'Silver');
            var cb2 = host && host.querySelector('[data-bp-sigill]');
            if (cb2 && cb2.checked) init.body.set('properties[Extra sigill – färg]', sigColor);
          }
          if (mode === 'sigill') init.body.set('properties[Sigillfärg]', sigColor);
        }
      } catch (e) { }
      return nativeFetch.apply(this, arguments);
    };
  }
})();
